import { useEffect, useState } from "react";

import { List, ListItem, Typography } from "@mui/material";
import AddIcon from "@material-ui/icons/Add";

import StatusChip from "../layoutComponents/StatusChip";
import { Fab } from "@material-ui/core";
import TableSearch from "../layoutComponents/TableSearch";
import TableSelect from "../layoutComponents/TableSelect";
import { requests } from "../requests";
import { moduleURL } from "../http/config";
import { StyledCircularProgress } from "../styles/StyledComponents";
import ProgressBar from "../layoutComponents/ProgressBar";

const styles = {
  listContainer: (
    isMobile,
    search,
    RaisedSearchBar,
    secondTabData,
    heightVH = false
  ) => ({
    height: isMobile
      ? search || RaisedSearchBar
        ? "calc(100% - 56px)"
        : "100%"
      : search || RaisedSearchBar
      ? heightVH
        ? "68vh"
        : "calc(100% - 72px)"
      : "100%",
    maxHeight: Boolean(secondTabData) ? "calc(100vh - 170px)" : "inherit",
    overflow: "auto",
    margin: "0 2px",
    width: "calc(100% - 4px)",
  }),
  listItem: (selected) => ({
    padding: "16px",
    borderBottom: "1px solid rgb(241, 154, 48)",
    fontSize: "14px",
    fontFamily: "Poppins",
    fontWeight: 500,
    // height: 70,
    cursor: "pointer",
    backgroundColor: selected ? "rgba(30, 53, 89, 0.09)" : "#fff",
  }),
  listNonItem: {
    padding: "16px",
    cursor: "pointer",
    backgroundColor: "#fff",
  },
  fab: {
    position: "absolute",
    bottom: 16,
    right: 16,
    color: "white",
  },
  search: {
    backgroundColor: "#FFF",
    borderRadius: "4px",
    width: "96%",
    margin: "4px",
    maxWidth: "380px",
    boxShadow:
      "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
  },
};

const CustomSubMenuList = (props) => {
  const [listData, setListData] = useState({
    data: [],
    paginationData: {},
  });
  const [isLoading, setIsLoading] = useState(false);
  // const [shouldUpdate, setShouldUpdate] = useState(true);

  const handleTabData = async (nextURL = "", selected = "") => {
    console.log("calledSubMenuApi", nextURL);
    setIsLoading(true);
    let option = {
      method: props.apiCall.method,
      url: nextURL || moduleURL(props.apiCall.url),
      params: nextURL
        ? {}
        : selected
        ? { ...props.apiCall.params, status: selected }
        : props.apiCall.params,
    };
    await requests(option)
      .then((res) => {
        let response = res.data?.results || res.data;
        setListData({
          data: [...listData.data, ...response],
          paginationData: {
            count: res.data.count,
            next: res.data.next,
            previous: res.data.previous,
          },
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setListData({});
        setIsLoading(false);
      });
  };

  const handleSearchTextOnChange = async (text) => {
    setIsLoading(true);
    let option = {
      method: props.apiCall.method,
      url: moduleURL(props.apiCall.url),
      params: text
        ? { ...props.apiCall.params, search: text }
        : props.apiCall.params,
    };
    await requests(option)
      .then((res) => {
        let response = res.data?.results || res.data;
        setListData({
          data: response,
          paginationData: {
            count: res.data.count,
            next: res.data.next,
            previous: res.data.previous,
          },
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setListData({});
        setIsLoading(false);
      });
  };

  const handleSelectOnChange = async (text) => {
    setIsLoading(true);
    let option = {
      method: props.apiCall.method,
      url: moduleURL(props.apiCall.url),
      params: text
        ? { ...props.apiCall.params, status: text }
        : props.apiCall.params,
    };
    await requests(option)
      .then((res) => {
        let response = res.data?.results || res.data;
        setListData({
          data: [...response],
          paginationData: {
            count: res.data.count,
            next: res.data.next,
            previous: res.data.previous,
          },
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setListData({});
        setIsLoading(false);
      });
  };

  function isScrolledToBottom(element) {
    if (!element) return false;
    return (
      element.scrollHeight -
        Math.round(element.scrollTop) -
        element.clientHeight <
      2
    );
  }

  const updateListItem = (id, newObj, key = "id") => {
    // setListData((prev) => {
    //   const updatedData = prev.data.map((item) =>
    //     item[key] === id ? { ...item, ...newObj } : item
    //   );
    //   return { ...prev, data: updatedData };
    // });
  };

  // when parent wants to update
  useEffect(() => {
    if (props.updateItem) {
      updateListItem(props.updateItem);
    }
  }, [props.updateItem]);

  useEffect(() => {
    const scrollElement = document.getElementById("scroll");

    const handleScroll = () => {
      if (
        isScrolledToBottom(scrollElement) &&
        listData.paginationData.next && // ✅ use correct next
        listData.paginationData.count > listData.data.length &&
        !isLoading
      ) {
        console.log("HERE SCROLL");
        handleTabData(listData.paginationData.next);
      }
    };

    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => {
        scrollElement.removeEventListener("scroll", handleScroll);
      };
    }
  }, [listData.paginationData.next, listData.data.length, isLoading]);

  useEffect(() => {
    console.log(props.checklayoutfnfromchild);
  }, [props.checklayoutfnfromchild]);

  useEffect(() => {
    console.log("RENDER", props.tabs[0].data);
    handleTabData();
  }, []);

  const {
    loading,
    listClickHandler,
    navigate,
    tabs,
    apiCall,
    fabClickHandler,
    fabDisabled=false,
    customItemRender = false,
    isMobile,
    search,
    RaisedSearchBar,
    RaisedSelectBar,
    RaisedMonthBar,
    secondTabData,
  } = props;

  console.log("CustomSubMenuList=", props);

  return (
    <div className="height-100">
      <div style={{ background: "#FFF" }}>
        {RaisedSelectBar?.visible ? (
          <TableSelect
            onChange={(value) => {
              handleSelectOnChange(value);
            }}
            selectedData={RaisedSelectBar?.selectedData}
            data={RaisedSelectBar?.data}
            {...RaisedSelectBar}
          />
        ) : null}

        {RaisedSearchBar?.visible ? (
          <TableSearch
            tableSearchField={{
              onChange: (text) => {
                handleSearchTextOnChange(text);
              },
            }}
            style={styles.search}
          />
        ) : null}
      </div>
      <>
        {listData?.data?.length ? (
          <>
            <div
              className="noTrack"
              style={styles.listContainer(
                isMobile,
                search,
                RaisedSearchBar || RaisedSelectBar || RaisedMonthBar,
                secondTabData?.array,
                Boolean(RaisedSearchBar?.module == "Ports")
              )}
              id={"scroll"}
            >
              <List disablePadding>
                {listData?.data &&
                  (Array.isArray(listData?.data)
                    ? listData?.data
                    : Object.values(listData?.data).flat()
                  )?.map((item, index) => (
                    <ListItem
                      key={index}
                      style={styles.listItem(
                        window?.location?.pathname.split("/")[3] == item?.id
                      )}
                      onClick={() => {
                        navigate(`${tabs[0]?.route}/${item?.id}`);
                        listClickHandler(item);
                      }}
                    >
                      <div className="d-flex d-flex-column width-100">
                        {customItemRender ? (
                          customItemRender(item)
                        ) : (
                          <div
                            className="d-flex d-flex-column"
                            style={{ margin: "6px 0" }}
                          >
                            <div
                              style={{
                                fontWeight:
                                  window?.location?.pathname.split("/")[3] ==
                                  item?.id
                                    ? "800"
                                    : "500",
                                color:
                                  window?.location?.pathname.split("/")[3] ==
                                  item?.id
                                    ? tabs[0]?.dispatchList
                                      ? "rgb(241, 154, 48)"
                                      : "rgb(30 53 89)"
                                    : "black",
                              }}
                            >
                              {item[tabs[0]?.primaryField]}
                            </div>
                            <div>
                              {tabs[0]?.dispatchList ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: tabs[0]?.dispatchList
                                      ? "center"
                                      : "space-between",
                                  }}
                                  className={
                                    tabs[0]?.dispatchList
                                      ? "d-flex width-100"
                                      : ""
                                  }
                                >
                                  <div
                                    style={{
                                      marginTop: "0",
                                      maxHeight: "48px",
                                      fontSize: "0.7rem",
                                      width: "100%",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      textAlign: "left",
                                      fontWeight:
                                        window?.location?.pathname.split(
                                          "/"
                                        )[3] == item?.id
                                          ? "800"
                                          : "500",
                                    }}
                                  >
                                    {tabs[0]?.onlySecondary ? (
                                      item?.[tabs[0]?.secondaryField]
                                    ) : tabs[0]?.progressBar ? (
                                      tabs[0]?.primaryFieldThirdFallback ===
                                      0 ? (
                                        "No Dispatches Yet!"
                                      ) : (
                                        <ProgressBar
                                          selectedIndex={
                                            window?.location?.pathname.split(
                                              "/"
                                            )[3] == item?.id
                                              ? "true"
                                              : "false"
                                          }
                                          completedChapters={
                                            item?.[tabs[0]?.primarySecondValue]
                                              ? Number(
                                                  item?.[
                                                    tabs[0]?.primarySecondValue
                                                  ]
                                                ).toFixed(3)
                                              : 0
                                          }
                                          totalChapters={
                                            tabs[0]?.salesList
                                              ? Number(
                                                  item?.[
                                                    tabs[0]
                                                      ?.primaryFieldThirdFallback
                                                  ] ?? 0
                                                ).toFixed(3)
                                              : tabs[0]?.dispatchList
                                              ? Number(
                                                  item?.[
                                                    tabs[0]?.secondaryField
                                                  ] ?? 0
                                                ).toFixed(3)
                                              : ""
                                          }
                                          unit={
                                            tabs[0]?.unit
                                              ? item?.unit || ""
                                              : ""
                                          }
                                          title1={"Dispatched"}
                                          title2={`Total`}
                                        />
                                      )
                                    ) : tabs[0]?.salesList ? (
                                      <>
                                        {/* {` Remaining ${
                                          item?.[tabs[0]?.primarySecondValue]
                                            ? Number(
                                                item?.[tabs[0]?.primarySecondValue]
                                              ).toFixed(0)
                                            : ""
                                        } MT | Total
                                                    ${
                                                      
                                                        ? Number(
                                                            primaryFieldThirdFallback
                                                          ).toFixed(0)
                                                        : ""
                                                    }MT`} */}
                                      </>
                                    ) : null}
                                  </div>
                                </div>
                              ) : tabs[0]?.secondaryField === "is_active" ? (
                                <StatusChip
                                  status={
                                    item?.[tabs[0]?.secondaryField]
                                      ? "Active"
                                      : "Inactive"
                                  }
                                />
                              ) : (
                                <div style={{ fontSize: 14, color: "#808080" }}>
                                  {item?.[tabs[0]?.secondaryField] || ""}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </ListItem>
                  ))}
                <ListItem key={"1000"} style={styles.listNonItem}>
                  <div
                    className="d-flex d-flex-column width-100"
                    style={{ height: 85 }}
                  />
                </ListItem>
              </List>
            </div>
            {/* {!fabDisabled && fabClickHandler && fabClickHandler ? (
              <Fab
                style={styles.fab}
                color="primary"
                aria-label="add"
                size="medium"
                onClick={fabClickHandler}
              >
                <AddIcon />
              </Fab>
            ) : (
              ""
            )} */}
          </>
        ) : loading ? (
          <div
            className="alignC justiyC d-flex"
            style={{ width: "100%", height: "100%" }}
          >
            <StyledCircularProgress />
          </div>
        ) : (
          <div
            className="alignC justifyC d-flex"
            style={{ width: "100%", height: "100%" }}
          >
          <Typography
            style={{
              fontFamily: "Poppins",
              fontSize: "14px",
              textAlign: "center",
              padding: "20px 0px",
            }}
          >
            {" "}
            No data yet!
          </Typography>
          </div>
        )}
        {!fabDisabled && fabClickHandler && fabClickHandler ? (
              <Fab
                style={styles.fab}
                color="primary"
                aria-label="add"
                size="medium"
                onClick={fabClickHandler}
              >
                <AddIcon />
              </Fab>
            ) : (
              ""
            )}
      </>
    </div>
  );
};

export default CustomSubMenuList;
